import moment from 'moment';

(() => {
  class ConfirmSubscriptionCancellationController {
    constructor($rootScope, $scope, $timeout, $interval, Users, toastr, $state, ngDialog) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        Users,
        toastr,
        $state,
        ngDialog,
        calculated_cancellation_date: $scope.ngDialogData.calculated_cancellation_date,
        cancelReasons: [],
        selectedReason: [],
        cancel_reason_code: null,
        saveEnabled: false
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.ngdialog").children(".ngdialog-content").draggable({
          handle: ".subscription-cancellation-popup-handler"
        });
      });
      this.getCancelReasons();
      var cancellation_date = this.calculated_cancellation_date.split("-");
      this.cancellation_date = new Date(parseInt(cancellation_date[0]), parseInt(cancellation_date[1]) - 1, parseInt(cancellation_date[2]));
      this.cancellation_date.setHours(0, 0, 0, 0); // Default Value for Radio Option

      this.status = 'cancelled';
      this.options = [{
        id: '1',
        name: 'User cancelled',
        value: 'cancelled'
      }, {
        id: '2',
        name: 'Treatment completed - provider only',
        value: 'completed'
      }];
      this.$timeout(function () {
        $("button.md-datepicker-button").css("margin-left", "34px");
        $("input.md-datepicker-input").css("background-color", "#EEEFF2");
      }, 100);
    }

    getCancelReasons() {
      this.Users.getCancelReasons().then(({
        data
      }) => {
        this.cancelReasons = data;
      });
    }

    setCancelReason() {
      this.cancel_reason_code = this.selectedReason[0].code;
    } // close() {
    //   this.$scope.closeThisDialog(null);
    // }


    save() {
      var response = {
        status: this.status,
        cancellation_date: moment(this.cancellation_date).format('YYYY-MM-DD')
      };

      if (this.status == 'cancelled') {
        response.cancel_reason_code = this.cancel_reason_code;
      } else {
        response.cancel_reason_code = "COMPLETED";
      }

      this.$scope.closeThisDialog(response);
    }

  }

  ConfirmSubscriptionCancellationController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "Users", "toastr", "$state", "ngDialog"];
  angular.module('pims').controller('ConfirmSubscriptionCancellationController', ConfirmSubscriptionCancellationController);
})();